import { render } from "./ProfileLayout.vue?vue&type=template&id=f450c8b8&scoped=true&ts=true&lang=pug"
import script from "./ProfileLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileLayout.vue?vue&type=style&index=0&id=f450c8b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f450c8b8"]])

export default __exports__